import React from 'react';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import format from '../../../../helpers/date';

import {
  AnchorLinks,
  Breadcrumbs,
  FadeWrapper,
  Hero,
  WysiwygField,
} from '../../../../components';

import {
  BREADCRUMB_URLS,
} from '../../../../config/constants';

import './style.scss';

const NodeProjectDetail = ({ entity, className }) => {
  const { t } = useTranslation();

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const projectPage = entity.toJS();

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const summary = entity.getIn(['body', 0, 'summary'], '');
  const date = entity.getIn(['created', 0, 'value']);
  const image = entity.getIn(['field_media_item', 0]);
  const imageTitle = entity.getIn(['field_media_item', 0, 'entity', 'field_caption', 0, 'value'], null);
  const showDate = entity.getIn(['field_show_date', 0, 'value']);

  const anchorLinks = projectPage.field_anchor_links;
  const paragraphs = projectPage.field_paragraphs;

  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');

  return (
    <article className="NodeProjectDetail">
      <Container>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              data={[
                { url: BREADCRUMB_URLS.projects[currentLanguage]?.what_we_do, title: t('breadcrumbs.what_we_do') },
                { url: BREADCRUMB_URLS.projects[currentLanguage]?.overview, title: t('entities.projects') },
                { title: title },
              ]}
            />
          </div>
        </div>
      </Container>

      {/* Start of Preface */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1">
            <div className="Preface">
              <FadeWrapper>
                <>
                  {showDate && (
                    <div className="Preface__content">
                      {t('entities.project')}, <span>{format((new Date(date)), 'd MMMM y')}</span>
                    </div>
                  )}
                  <div className="Preface__title">
                    <h1>{title}</h1>
                  </div>
                </>
              </FadeWrapper>
              <FadeWrapper delay={100}>
                <div className="Preface__body">
                  <WysiwygField
                    property="schema:text"
                    html={summary}
                  />
                </div>
              </FadeWrapper>

              {link && linkTitle && (
                <FadeWrapper delay={200}>
                  <div className="Preface__link">
                    <Button
                      href={link}
                      target={linkTarget}
                      className="Button--cta"
                    >
                      {linkTitle}
                    </Button>
                  </div>
                </FadeWrapper>
              )}
            </div>
          </div>
        </div>
      </Container>
      {/* End of Preface */}

      {/* Start of Hero */}
      {image && (
        <Container>
          <div className="row">
            <div className="col-12">
              <Hero
                image={image}
                description={imageTitle}
              />
            </div>
          </div>
        </Container>
      )}
      {/* End of Hero */}

      {/* Start of AnchorLinks */}
      {anchorLinks.length > 0 && (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <AnchorLinks
                anchorLinks={anchorLinks}
                paragraphs={paragraphs}
              />
            </div>
          </div>
        </Container>
      )}
      {/* End of AnchorLinks */}

      {/* Start of Body */}
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1">
            <FadeWrapper delay={300}>
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </FadeWrapper>
          </div>
        </div>
      </Container>
      {/* End of Body */}

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <FadeWrapper key={`paragraph:${id}`}>
                <Paragraph
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </FadeWrapper>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

    </article>
  );
};

export default NodeProjectDetail;
